<template>
  <section class="smart2-page-wrapper">
    <div class="content-box">
      <div class="font-box">
        <h3 class="font1-5 font-item">
          <span class="cus-linear">来电通知</span> <br />无需跳转即可接通
        </h3>
        <h3 class="font2-5 font-item">
          <span class="cus-linear">信息收发</span> <br />主动弹出信息卡片
        </h3>
        <h3 class="font3-5 font-item">
          <span class="cus-linear">应用小窗</span> <br />各类实况灵动呈现
        </h3>
      </div>
      <m-video
        class="end_video"
        poster="@/auto/assets/video/5/bg_1.5x.png"
        src="@/auto/assets/video/smart2.mp4"
        width="100%"
        muted
        loop
        ref="end_video"
        @timeupdate="timeupdate($event)"
      ></m-video>
    </div>
    <div class="seat"></div>
  </section>
</template>

<script>
import { videoPlayByVisibleArea } from '@/utils'

export default {
  name: 'ToBeEnd_Aircondition',
  data() {
    return {
      thisTime: false,
    }
  },
  watch: {
    thisTime(val) {
      if (val == 0) {
        this.fontChange1()
      }
      if (val == 3) {
        this.fontChange2()
      }
      if (val == 9) {
        this.fontChange3()
      }
    },
  },
  methods: {
    fontChange3() {
      this.$gsap.to('.font2-5', { rotateX: '90', top: -75, opacity: 0 })
      this.$gsap.to('.font3-5', {
        rotateX: '0',
        top: 0,
        opacity: 1,
        onComplete: () => {
          this.$gsap.to('.font2-5', {
            rotateX: '-90',
            top: 75,
            opacity: 0,
            duration: 0,
          })
        },
      })
    },
    fontChange2() {
      this.$gsap.to('.font1-5', { rotateX: '90', top: -75, opacity: 0 })
      this.$gsap.to('.font2-5', {
        rotateX: '0',
        top: 0,
        opacity: 1,
        onComplete: () => {
          this.$gsap.to('.font1-5', {
            rotateX: '-90',
            top: 75,
            opacity: 0,
            duration: 0,
          })
        },
      })
    },

    fontChange1() {
      this.$gsap.to('.font3-5', { rotateX: '90', top: -75, opacity: 0 })
      this.$gsap.to('.font1-5', {
        rotateX: '0',
        top: 0,
        opacity: 1,
        onComplete: () => {
          this.$gsap.to('.font3-5', {
            rotateX: '-90',
            top: 75,
            opacity: 0,
            duration: 0,
          })
        },
      })
    },
    timeupdate(e) {
      const currentTime = e.target.currentTime
      if (currentTime >= 9) {
        this.thisTime = 9
        return
      }
      if (currentTime >= 3) {
        this.thisTime = 3
        return
      }
      if (currentTime >= 0) {
        this.thisTime = 0
        return
      }
    },
    videoRunner() {
      const end_video = this.$refs.end_video
      end_video && videoPlayByVisibleArea(end_video)
    },
    // pagePin() {
    //   this.$gsap.timeline({
    //     scrollTrigger: {
    //       trigger: '.smart2-page-wrapper',
    //       end: '+8000',
    //       pin: true,
    //     },
    //   })
    // },
    onPreload() {
      // this.pagePin()
      this.videoRunner()
    },
  },
}
</script>

<style lang="less" scoped>
// 占位
.seat {
  height: 3000px;
  width: 100%;
}
.smart2-page-wrapper {
  // height: 100vh;
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: #17181c;
  position: sticky;
  top: 0;
  .content-box {
    // margin: auto;
    position: relative;
    width: 100%;
    height: 100%;
    // position: absolute;
    top: 0;
    .font-box {
      width: 100%;
      position: absolute;
      top: 46%;
      left: 12.4%;
      z-index: 1;

      perspective: 500;
      -webkit-perspective: 500;
      -moz-perspective: 500;
      backface-visibility: hidden;
      .font-item {
        // border: 1px solid #f00;
        position: absolute;
        transform-origin: center center -55px;
        width: 100%;
        color: #fff;
        font-family: Flyme Sans VF;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 82px; /* 128.125% */
        letter-spacing: 3.84px;
      }
      .font1-5 {
        top: 0;
      }
      .font2-5,
      .font3-5 {
        top: 75px;
        transform: rotateX(-90deg);
        opacity: 0;
      }
    }
  }
  .end_video {
    // border: 10px solid #000000;
    // border-radius: 12px;
    // margin-top: -300px;
    overflow: hidden;
  }
}
</style>
